import { apiGetAuth, apiPostAuth, apiPutAuth } from '@/utils/api'
import { API_EMAIL_BROADCAST } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  log_notification_email_list: {
    isLoading: false,
    data: {}
  },
  email_broadcast_list: {
    isLoading: false,
    data: {}
  },
  detail_email_broadcast: {
    isLoading: false,
    data: {}
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_LOG_NOTIFICATION_EMAIL_LIST": (state, payload) => {
    state.log_notification_email_list = payload
  },
  "SET_EMAIL_BROADCAST_LIST": (state, payload) => {
    state.email_broadcast_list = payload
  },
  "SET_DETAIL_EMAIL_BROADCAST": (state, payload) => {
    state.detail_email_broadcast = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getLogNotificationEmailList(context, payload) {
    context.commit('SET_LOG_NOTIFICATION_EMAIL_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_EMAIL_BROADCAST?.LIST_LOG_EMAIL, payload)
      context.commit('SET_LOG_NOTIFICATION_EMAIL_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch (error) {
      context.commit('SET_LOG_NOTIFICATION_EMAIL_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(error)
    }
  },
  async getEmailBroadcastList(context, payload) {
    context.commit('SET_EMAIL_BROADCAST_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_EMAIL_BROADCAST?.LIST_BROADCAST, payload)
      context.commit('SET_EMAIL_BROADCAST_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch (error) {
      context.commit('SET_EMAIL_BROADCAST_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(error)
    }
  },
  async getDetailEmailBroadcast(context, payload) {
    context.commit('SET_DETAIL_EMAIL_BROADCAST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_EMAIL_BROADCAST.BY_ID(payload))
      context.commit('SET_DETAIL_EMAIL_BROADCAST', { 
        isLoading: false,
        data: response?.data
      })
    } catch(error) {
      context.commit('SET_DETAIL_EMAIL_BROADCAST', { 
        isLoading: false,
        data: {}
      })
    }
  },
  async createEmailBroadcast(context, payload) {
    const response = await apiPostAuth(API_EMAIL_BROADCAST.CREATE_EMAIL_BROADCAST, payload)
    return response?.data
  },
  async updateEmailBroadcast(context, payload) {
    const response = await apiPutAuth(API_EMAIL_BROADCAST.BY_ID(payload?.id), payload?.reqBody)
    return response?.data
  },
  async resendEmailNotification(context, payload) {
    try {
      const response = await apiPostAuth(API_EMAIL_BROADCAST.RESEND_EMAIL(payload))
      return response?.data
    } catch(error) {
      notificationDanger(error)
    }
  }
}

const getters = {
  get_log_notification_email_list: state => {
    return state.log_notification_email_list
  },
  get_email_broadcast_list: state => {
    return state.email_broadcast_list
  },
  get_detail_email_broadcast: state => {
    return state.detail_email_broadcast
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
